import { MonthlyLimit } from "../pages/shared/models/monthly-limit";
import { Product } from "../pages/shared/models/order/product.model";

function getOrderOverallCounts(monthlyLimit: MonthlyLimit, products: Product[]) {
    const weightUnit = monthlyLimit?.weightUnit;
    const currency = monthlyLimit?.currency;

    return products.reduce(
        (counts, product) => {
            // TODO: add price calculation
            counts.overallCount = counts.overallCount + 1;

            counts.overallWeight = product.weightUnit === weightUnit
                ? counts.overallWeight + (product.weight || 0)
                : weightUnit?.weightUnitId === 2
                    ? counts.overallWeight + (product.weight || 0) * 0.45
                    : counts.overallWeight + (product.weight || 0) * 2.20462

            return counts;
        }, { overallCount: 0, overallWeight: 0, overallPrice: 0 }
    );
}

export default {
    getOrderOverallCounts,
};

export interface MonthlyLimitValidations {
    exceedsByCount?: boolean;
    exceedsByWeight?: boolean;
    exceedsByPrice?: boolean;
}